<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="iconfont icon--shebei"></i> 设备列表
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <!-- <el-row :gutter="18">
                <el-col :span="24">
                    <el-row :gutter="20" class="mgb20">
                        <el-col :span="6">
                            <el-card shadow="hover" :body-style="{padding: '0px'}">
                                <div class="grid-content grid-con-1">
                                    <i class="el-icon-lx-people grid-con-icon"></i>
                                    <div class="grid-cont-right">
                                        <div class="grid-num">1234</div>
                                        <div>用户访问量</div>
                                    </div>
                                </div>
                            </el-card>
                        </el-col>
                        <el-col :span="6">
                            <el-card shadow="hover" :body-style="{padding: '0px'}">
                                <div class="grid-content grid-con-1">
                                    <i class="el-icon-lx-people grid-con-icon"></i>
                                    <div class="grid-cont-right">
                                        <div class="grid-num">1234</div>
                                        <div>用户访问量</div>
                                    </div>
                                </div>
                            </el-card>
                        </el-col>
                        <el-col :span="6">
                            <el-card shadow="hover" :body-style="{padding: '0px'}">
                                <div class="grid-content grid-con-2">
                                    <i class="el-icon-lx-notice grid-con-icon"></i>
                                    <div class="grid-cont-right">
                                        <div class="grid-num">321</div>
                                        <div>系统消息</div>
                                    </div>
                                </div>
                            </el-card>
                        </el-col>
                        <el-col :span="6">
                            <el-card shadow="hover" :body-style="{padding: '0px'}">
                                <div class="grid-content grid-con-3">
                                    <i class="el-icon-lx-goods grid-con-icon"></i>
                                    <div class="grid-cont-right">
                                        <div class="grid-num">5000</div>
                                        <div>数量</div>
                                    </div>
                                </div>
                            </el-card>
                        </el-col>
                    </el-row>
                </el-col>
            </el-row>-->

            <div class="handle-box">
                <!-- <el-popover
                    ref="popoverRef"
                    placement="bottom-start"
                    width="480"
                    trigger="click"
                    :v-model="true"
                >
                    <el-form ref="searchform" :model="searchform" label-width="120px">
                        <el-form-item label="设备类型">
                            <el-select v-model="searchform.deviceType" placeholder="请选择">
                                <el-option label="智能井盖" value="智能井盖"></el-option>
                                <el-option label="水位流速监测" value="水位流速监测"></el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item label="报警状态">
                            <el-radio :label="0" v-model="searchform.alarmStatus">正常</el-radio>
                            <el-radio :label="1" v-model="searchform.alarmStatus">报警</el-radio>
                        </el-form-item>
                        <el-form-item label="维护状态">
                            <el-radio label="0" v-model="searchform.maintain">正常</el-radio>
                            <el-radio label="1" v-model="searchform.maintain">维护</el-radio>
                        </el-form-item>
                        <el-form-item label="信号强度">
                            <el-col :span="11">
                                <el-input
                                    v-model="searchform.rssi1"
                                    type="number"
                                    placeholder="信号强度范围"
                                ></el-input>
                            </el-col>
                            <el-col class="line" :span="2">-</el-col>
                            <el-col :span="11">
                                <el-input
                                    v-model="searchform.rssi2"
                                    type="number"
                                    placeholder="信号强度范围"
                                ></el-input>
                            </el-col>
                        </el-form-item>
                        <el-form-item label="小区ID">
                            <el-input
                                v-model="searchform.cellID"
                                type="number"
                                placeholder="请输入物理小区ID"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="物理小区标识">
                            <el-input
                                v-model="searchform.pci"
                                type="number"
                                placeholder="请输入物理小区标识"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="软件版本">
                            <el-input v-model="searchform.software" placeholder="请输入软件版本，例v3.0"></el-input>
                        </el-form-item>
                        <el-form-item label="设备创建时间">
                            <el-col :span="11">
                                <el-date-picker
                                    type="datetime"
                                    placeholder="开始时间"
                                    v-model="searchform.createTime1"
                                    style="width: 100%;"
                                ></el-date-picker>
                            </el-col>
                            <el-col class="line" :span="2">-</el-col>
                            <el-col :span="11">
                                <el-date-picker
                                    type="datetime"
                                    placeholder="结束时间"
                                    v-model="searchform.createTime2"
                                    style="width: 100%;"
                                ></el-date-picker>
                            </el-col>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="onSubmit">搜索</el-button>
                            <el-button type="primary" @click="onResetSubmit">重置</el-button>
                            <el-button @click="canaleSubmit">取消</el-button>
                        </el-form-item>
                    </el-form>
                    <el-button slot="reference" type="primary">
                        条件查找
                        <i class="el-icon-arrow-down el-icon--right"></i>
                    </el-button>
                </el-popover> -->
                <el-input v-model="query.searchValue" placeholder="请输入设备名称" class="handle-input mr10 ml10"></el-input>
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
                <el-button type="primary" icon="el-icon-refresh-right" @click="resetSearch">重置</el-button>
            </div>

            <el-table :data="tableData" border class="table" ref="multipleTable" header-cell-class-name="table-header"
                @selection-change="handleSelectionChange">
                <el-table-column type="selection" width="55" align="center"></el-table-column>
                <el-table-column align="center" fixed prop="deviceName" width="120" label="设备名称"></el-table-column>
                <el-table-column align="center" prop="openStatus" width="120" label="报警状态">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.alarmStatus ? 'danger' : 'success'">{{ scope.row.alarmStatus ? '报警' :
                    '正常'
                            }}</el-tag>
                    </template>
                </el-table-column>

                <el-table-column align="center" prop="maintain" width="120" label="维护状态">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.maintain == '1' ? 'danger' : 'success'">{{ scope.row.maintain == "1" ?
                    '维护中' : '正常' }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="deviceType" width="120" label="设备类型"></el-table-column>

                <el-table-column align="center" prop="rssi" width="150" label="信号强度">
                    <template slot-scope="scope">{{ scope.row.rssi ? scope.row.rssi : (scope.row.csqSignal ?
                    scope.row.csqSignal : (scope.row.signal ? scope.row.signal : '未采集')) }}</template>
                </el-table-column>
                <el-table-column align="center" prop="cellID" label="小区ID">
                    <template slot-scope="scope">{{ scope.row.cellID ? scope.row.cellID : '未采集' }}</template>
                </el-table-column>
                <el-table-column align="center" prop="pci" label="物理小区标识">
                    <template slot-scope="scope">{{ scope.row.pci ? scope.row.pci : '未采集' }}</template>
                </el-table-column>
                <el-table-column align="center" prop="software" label="软件版本"></el-table-column>

                <el-table-column label="操作" width="180" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" @click="deviceDetail(scope.$index, scope.row)">查看详情</el-button>
                        <el-button type="text" :class="scope.row.maintain == '1' ? '' : 'red'"
                            @click="changeMaintain(scope.$index, scope.row)">{{ scope.row.maintain == "1" ? '解除维护' :
                    '加入维护'
                            }}</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination background layout="total, prev, pager, next" :current-page="query.pageIndex"
                    :page-size="query.pageSize" :total="pageTotal" @current-change="handlePageChange"></el-pagination>
            </div>
        </div>

        <el-dialog title="编辑" :visible.sync="editVisible" width="30%">
            <el-form label-width="70px">
                <el-form-item label="经度">
                    <el-input v-model="editLongitude" placeholder="请输入经度"></el-input>
                </el-form-item>
                <el-form-item label="纬度">
                    <el-input v-model="editLatitude" placeholder="请输入纬度"></el-input>
                </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEditLocation">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { QueryProjectDevice, UpdateDeviceLocation, UpdateProjectName, CondProjectDevice, ChangeMaintain } from '../../api/index';
import moment from 'moment';
export default {
    name: 'basetable',
    data() {
        return {
            searchform: {
                deviceType: '智能井盖',
                alarmStatus: 0,
                openStatus: 0,
                maintain: '0',
                rssi1: '',
                rssi2: '',
                cellID: '',
                pci: '',
                software: '',
                createTime1: '',
                createTime2: ''
            },
            // 编辑项目名称值
            editLongitude: '',
            editLatitude: '',
            editDeviceId: '',
            projectId: '',
            query: {
                searchTag: 'deviceName',
                searchValue: '',
                pageIndex: 1,
                pageSize: 10
            },
            tableData: [],
            multipleSelection: [],
            delList: [],
            editVisible: false,
            pageTotal: 0,
            form: {},
            idx: -1,
            id: -1
        };
    },
    activated() {
        this.getData();
        this.projectId = this.$route.query.projectId;
    },
    created() {
        this.getData();
        this.projectId = this.$route.query.projectId;
    },
    methods: {
        // 前往设备详情界面
        deviceDetail(index, row) {
            switch (row.deviceType) {
                case '智能井盖':
                    this.$router.push(`ADeviceDetail?projectId=${this.$route.query.projectId}&deviceId=${row.id}`);
                    break;
                case '水位流速监测':
                    this.$router.push(`ADeviceDetail1?projectId=${this.$route.query.projectId}&deviceId=${row.id}`);
                    break;
                case '雨量监测':
                    this.$router.push(`ADeviceDetail2?projectId=${this.$route.query.projectId}&deviceId=${row.id}`);
                    break;
                case '智能井盖4G':
                    this.$router.push(`ADeviceDetail4?projectId=${this.$route.query.projectId}&deviceId=${row.id}`);
                    break;
                case '积水监测':
                    this.$router.push(`ADeviceDetail5?projectId=${this.$route.query.projectId}&deviceId=${row.id}`);
                    break;
                case '智能井盖L3W':
                    this.$router.push(`ADeviceDetail?projectId=${this.$route.query.projectId}&deviceId=${row.id}`);
                    break;
                case '水质监测':
                    this.$router.push(`ADeviceDetail6?projectId=${this.$route.query.projectId}&deviceId=${row.id}`);
                    break;
                case '雷达水位计':
                    this.$router.push(`ADeviceDetail7?projectId=${this.$route.query.projectId}&deviceId=${row.id}`);
                    break;
                case '不锈钢井盖':
                    this.$router.push(`ADeviceDetail8?projectId=${this.$route.query.projectId}&deviceId=${row.id}`);
                    break;
                case '智能井盖V4':
                    this.$router.push(`ADeviceDetail9?projectId=${this.$route.query.projectId}&deviceId=${row.id}`);
                    break;
                default:
                    break;
            }
        },
        // 切换设备维护状态
        async changeMaintain(index, row) {
            this.$confirm('此操作将切换设备维护状态, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(async () => {
                    const result = await ChangeMaintain({
                        projectId: this.$route.query.projectId,
                        deviceName: row.deviceName,
                        maintain: row.maintain
                    });
                    console.log(result);
                    if (result.code !== 200) {
                        return;
                    }
                    this.getData();
                    this.$message({
                        type: 'success',
                        message: '切换成功!'
                    });
                })
                .catch(() => { });
        },
        // 重置条件搜索
        onResetSubmit() {
            this.searchform = {
                deviceType: '智能井盖',
                alarmStatus: 0,
                openStatus: 0,
                maintain: '0',
                rssi1: '',
                rssi2: '',
                cellID: '',
                pci: '',
                software: '',
                createTime1: '',
                createTime2: ''
            };
        },
        // 取消条件搜索
        canaleSubmit() {
            this.searchform = {
                deviceType: '智能井盖',
                alarmStatus: 0,
                openStatus: 0,
                maintain: '0',
                rssi1: '',
                rssi2: '',
                cellID: '',
                pci: '',
                software: '',
                createTime1: '',
                createTime2: ''
            };
            this.$refs['popoverRef'].doClose();
        },
        // 重置搜索条件
        resetSearch() {
            this.query = {
                searchTag: 'deviceName',
                searchValue: '',
                pageIndex: 1,
                pageSize: 10
            };
            this.searchform = {
                deviceType: '智能井盖',
                alarmStatus: 0,
                openStatus: 0,
                maintain: '0',
                rssi1: '',
                rssi2: '',
                cellID: '',
                pci: '',
                software: '',
                createTime1: '',
                createTime2: ''
            };
            this.getData();
        },
        async onSubmit() {
            this.$set(this.query, 'pageIndex', 1);
            let searchform = JSON.parse(JSON.stringify(this.searchform));

            searchform.cellID = this.searchform.cellID ? this.searchform.cellID : 99999999;
            searchform.createTime1 = new Date(this.searchform.createTime1).getTime() ? new Date(this.searchform.createTime1).getTime() : 0;
            searchform.createTime2 = new Date(this.searchform.createTime2).getTime()
                ? new Date(this.searchform.createTime2).getTime()
                : new Date().getTime();
            searchform.maintain = this.searchform.maintain;
            searchform.pci = this.searchform.pci ? this.searchform.pci : 99999999;
            searchform.rssi1 = this.searchform.rssi1 ? this.searchform.rssi1 : -200;
            searchform.rssi2 = this.searchform.rssi2 ? this.searchform.rssi2 : 200;
            searchform.software = this.searchform.software.trim() ? this.searchform.software.trim() : '%';
            searchform.limit = this.query.pageSize;
            searchform.offset = this.query.pageIndex - 1;
            searchform.projectId = this.$route.query.projectId;

            searchform.alarmStatus = this.searchform.alarmStatus;

            let searchObj = {
                cellID: searchform.cellID,
                createTime1: searchform.createTime1,
                createTime2: searchform.createTime2,
                maintain: searchform.maintain,
                pci: searchform.pci,
                rssi1: searchform.rssi1,
                rssi2: searchform.rssi2,
                software: searchform.software,
                limit: searchform.limit,
                offset: searchform.offset,
                projectId: searchform.projectId
            };

            const result = await CondProjectDevice(searchObj);

            if (result.code !== 200) {
                return;
            }

            let data = result.data.rows;

            let dataArr = [];
            for (let i = 0; i < data.length; i++) {
                let obj = data[i];
                obj.createtime = moment(data[i].createTime * 1).format('YYYY-MM-DD HH:mm:ss');
                obj.updatetime = moment(data[i].updateTime * 1).format('YYYY-MM-DD HH:mm:ss');
                // obj.alarmStatus = 0;
                // console.log(obj.deviceType);

                // switch (obj.deviceType) {
                //     case '智能井盖':
                //         if (obj.openStatus) {
                //             obj.alarmStatus = 1;
                //         }
                //         break;
                //     case '水位流速监测':
                //         if (
                //             (obj.alarmLevel2 && obj.alarmLevel2 <= obj.level2 * 1) ||
                //             (obj.alarmLevel1 && obj.alarmLevel1 <= obj.level1 * 1)
                //         ) {
                //             obj.alarmStatus = 1;
                //         }
                //         break;
                //     default:
                //         break;
                // }
                dataArr.push(obj);
            }

            console.log(dataArr);

            let newData = dataArr.filter((item, index) => {

                // 判断设备类型是否否合
                if (item.deviceType != searchform.deviceType) {
                    console.log('设备类型不符合');
                    console.log(item.deviceType);
                    console.log(searchform.deviceType);

                    return;
                }
                // 判断报警状态是否符合
                if (item.alarmStatus != searchform.alarmStatus) {
                    console.log('报警状态不符合');
                    console.log(item.alarmStatus);
                    console.log(searchform.alarmStatus);
                    return;
                }
                return item;
            });
            console.log(newData);

            this.pageTotal = newData.length;
            this.tableData = newData;
            this.$refs['popoverRef'].doClose();
        },
        async getData() {
            const { data } = await QueryProjectDevice({
                searchTag: this.query.searchTag,
                searchValue: this.query.searchValue ? this.query.searchValue : '%',
                limit: this.query.pageSize,
                offset: this.query.pageIndex - 1,
                projectId: this.$route.query.projectId
            });
            console.log(data);
            this.pageTotal = data.count;
            let dataArr = [];
            for (let i = 0; i < data.rows.length; i++) {
                // && data.rows[i].deviceName != '3X1FK83J003859F5'
                if (data.rows[i].deviceName != 'J8C149912846VK53') {
                    let obj = data.rows[i];
                    obj.createtime = moment(data.rows[i].createTime * 1).format('YYYY-MM-DD HH:mm:ss');
                    obj.updatetime = moment(data.rows[i].updateTime * 1).format('YYYY-MM-DD HH:mm:ss');
                    obj.alarmStatus = 0; //报警状态 0 未报警 1 报警
                    // 根据设备类型返回报警状态
                    switch (obj.deviceType) {
                        case '智能井盖':
                            if (obj.openStatus) {
                                obj.alarmStatus = 1;
                            }
                            break;
                        case '水位流速监测':
                            if (
                                (obj.alarmLevel2 && obj.alarmLevel2 <= obj.level2 * 1) ||
                                (obj.alarmLevel1 && obj.alarmLevel1 <= obj.level1 * 1)
                            ) {
                                obj.alarmStatus = 1;
                            }
                            break;
                        case '雨量监测':
                            if (obj.alarmRain && obj.alarmRain <= obj.momentRain * 1) {
                                obj.alarmStatus = 1;
                            }
                            break;
                        default:
                            break;
                    }
                    dataArr.push(obj);
                }

            }
            this.tableData = dataArr;
            console.log(dataArr);
        },

        // 打开编辑弹窗
        async editLocationF(index, row) {
            this.editVisible = true;
            console.log(row);
            this.editLongitude = row.longitude;
            this.editLatitude = row.latitude;
            this.editDeviceId = row.id;
        },
        // 保存编辑值
        async saveEditLocation() {
            const result = await UpdateDeviceLocation({
                id: this.editDeviceId,
                longitude: this.editLongitude,
                latitude: this.editLatitude,
                projectId: this.projectId
            });
            this.$message.success('修改成功');
            this.editVisible = false;
            this.getData();
        },

        // 跳转项目绑定企业详情
        async goProjectBind(index, row) {
            this.$router.push(`AProjectBind?projectId=${row.projectId}`);
        },

        // 触发搜索按钮
        handleSearch() {
            this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },
        // 删除操作
        handleDelete(index, row) {
            // 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    this.$message.success('删除成功');
                    this.tableData.splice(index, 1);
                })
                .catch(() => { });
        },
        // 多选操作
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        delAllSelection() {
            const length = this.multipleSelection.length;
            let str = '';
            this.delList = this.delList.concat(this.multipleSelection);
            for (let i = 0; i < length; i++) {
                str += this.multipleSelection[i].name + ' ';
            }
            this.$message.error(`删除了${str}`);
            this.multipleSelection = [];
        },
        // 编辑操作
        handleEdit(index, row) {
            this.idx = index;
            this.form = row;
            this.editVisible = true;
        },
        // 保存编辑
        saveEdit() {
            this.editVisible = false;
            this.$message.success(`修改第 ${this.idx + 1} 行成功`);
            this.$set(this.tableData, this.idx, this.form);
        },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageIndex', val);
            this.getData();
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.ml10 {
    margin-left: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.el-row {
    margin-bottom: 20px;
}

.grid-content {
    display: flex;
    align-items: center;
    height: 100px;
}

.grid-cont-right {
    flex: 1;
    text-align: center;
    font-size: 14px;
    color: #999;
}

.grid-num {
    font-size: 30px;
    font-weight: bold;
}

.grid-con-icon {
    font-size: 50px;
    width: 100px;
    height: 100px;
    text-align: center;
    line-height: 100px;
    color: #fff;
}

.grid-con-1 .grid-con-icon {
    background: rgb(45, 140, 240);
}

.grid-con-1 .grid-num {
    color: rgb(45, 140, 240);
}

.grid-con-2 .grid-con-icon {
    background: rgb(100, 213, 114);
}

.grid-con-2 .grid-num {
    color: rgb(45, 140, 240);
}

.grid-con-3 .grid-con-icon {
    background: rgb(242, 94, 67);
}

.grid-con-3 .grid-num {
    color: rgb(242, 94, 67);
}

.user-info {
    display: flex;
    align-items: center;
    padding-bottom: 20px;
    border-bottom: 2px solid #ccc;
    margin-bottom: 20px;
}

.user-avator {
    width: 120px;
    height: 120px;
    border-radius: 50%;
}

.user-info-cont {
    padding-left: 50px;
    flex: 1;
    font-size: 14px;
    color: #999;
}

.user-info-cont div:first-child {
    font-size: 30px;
    color: #222;
}

.user-info-list {
    font-size: 14px;
    color: #999;
    line-height: 25px;
}

.user-info-list span {
    margin-left: 70px;
}

.mgb20 {
    margin-bottom: 20px;
}

.todo-item {
    font-size: 14px;
}

.todo-item-del {
    text-decoration: line-through;
    color: #999;
}

.schart {
    width: 100%;
    height: 300px;
}

.line {
    text-align: center;
}
</style>
